import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { StaticImageUrlPipe } from '@rma/generic/util/pipes/static-image-url';
import { LG_RENOWNED_LOGO_PATH, SM_RENOWNED_LOGO_PATH } from '@rma/layout/public/util-layout';

@Component({
  selector: 'rma-header-logo',
  templateUrl: 'header-logo.component.html',
  styleUrls: ['header-logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule, StaticImageUrlPipe, TranslocoModule],
})
export class HeaderLogoComponent {
  protected readonly lgRenownedLogoPath = LG_RENOWNED_LOGO_PATH;
  protected readonly smRenownedLogoPath = SM_RENOWNED_LOGO_PATH;
}
